<sura-admin [linkActive]="linkActive"></sura-admin>
<div class="container  pl-0 pr-0">
    <div style="padding: 10px 0px"></div>
    <div class="card shadow mb-5 bg-white rounded " style="margin: auto;">
        <div class="card-header">
            Importar Data
        </div>

        <form class="card-body" [formGroup]="participesFondoForm" (ngSubmit)="onDownloadParticipesFondo()">
            <div class="d-flex justify-content-start align-items-stretch">
                <div class="mr-3">
                    <mat-form-field appearance="outline">
                        <mat-label>Fondo:</mat-label>
                        <mat-select formControlName="codigoAlterno" name="codigoAlterno" placeholder="Seleccione">
                            <mat-option *ngFor="let element of listaOrganizadores" [value]="element.codigoAlterno">
                                {{element.organizador}}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="participesFondoForm.controls.codigoAlterno.errors?.required" class="error">
                            Seleccione un fondo</mat-error>
                    </mat-form-field>
                </div>

                <div class="ml-3 mr-3">
                    <mat-form-field appearance="outline">
                        <mat-label>Fecha:</mat-label>
                        <input matInput formControlName="fechaRegistro" name="fechaRegistro"
                            [matDatepicker]="picker" placeholder="dd/mm/yyyy">
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker disabled="false"></mat-datepicker>
                        <mat-error *ngIf="participesFondoForm.controls.fechaRegistro.errors?.required" class="error">
                            Ingrese una fecha correcta</mat-error>
                    </mat-form-field>
                </div>

                <div class="ml-3">
                    <button mat-mini-fab type="submit" color="primary" matTooltip="Buscar">
                        <mat-icon>search</mat-icon>
                    </button>
                </div>
            </div>
        </form>

        <mat-divider></mat-divider>

        <form *ngIf="showUploadForm" class="card-body" [formGroup]="uploadParticipesFondoForm"
            (ngSubmit)="onUploadParticipesFondo()">
            <div class="d-flex justify-content-start align-items-stretch">
                <div class="mr-3">
                    <mat-form-field appearance="outline">
                        <mat-label>Nro. Asamblea:</mat-label>
                        <input matInput type="text" formControlName="numeroAsamblea"
                            (keypress)="fnKeyDownNumeric($event)" (keyup)="fnNumericMobile($event)">
                        <mat-error *ngIf="uploadParticipesFondoForm.controls.numeroAsamblea.errors?.required"
                            class="error">Ingrese n&uacute;mero de asamblea.</mat-error>
                        <mat-error *ngIf="uploadParticipesFondoForm.controls.numeroAsamblea.errors?.maxlength"
                            class="error">Ingrese n&uacute;mero de asamblea de 6 digitos como m&aacute;ximo.</mat-error>
                    </mat-form-field>
                </div>

                <div class="ml-3">
                    <button mat-raised-button type="submit" cdkFocusInitial matTooltip="Importar" color="primary">
                        <mat-icon aria-label="icon-button icon">import_export</mat-icon>&nbsp;&nbsp;<strong>Importar Data</strong>
                    </button>
                </div>
            </div>
        </form>
    </div>
</div>